'use client'

import { Users, Zap, DollarSign, TrendingUp } from 'lucide-react'

const stats = [
  {
    name: 'Total Executions',
    value: '18,750',
    change: '+12%',
    changeType: 'positive',
    icon: Zap,
  },
  {
    name: 'Active Clients',
    value: '47',
    change: '+8%',
    changeType: 'positive',
    icon: Users,
  },
  {
    name: 'Monthly Revenue',
    value: '$12,450',
    change: '+15%',
    changeType: 'positive',
    icon: DollarSign,
  },
  {
    name: 'Success Rate',
    value: '94.2%',
    change: '+2%',
    changeType: 'positive',
    icon: TrendingUp,
  },
]

export default function StatsGrid() {
  return (
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
      {stats.map((stat) => (
        <div
          key={stat.name}
          className="overflow-hidden rounded-lg bg-white px-4 py-5 shadow border border-gray-200 sm:p-6"
        >
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <stat.icon className="h-8 w-8 text-blue-600" />
            </div>
            <div className="ml-5 w-0 flex-1">
              <dl>
                <dt className="text-sm font-medium text-gray-500 truncate">{stat.name}</dt>
                <dd className="flex items-baseline">
                  <div className="text-2xl font-semibold text-gray-900">{stat.value}</div>
                  <div className="ml-2 flex items-baseline text-sm font-semibold text-green-600">
                    {stat.change}
                  </div>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
